// One cold-chain overview subscription for the whole Live Map page: the vehicle-list chips and the
// telemetry card both read from it, so 1400 rows never fetch and there is exactly one poll.
// The provider is inert (no request, null context) when the org lacks the module.
import { createContext, useContext, useMemo } from 'react';
import useFeatures from '@/hooks/useFeatures';
import useColdChainOverview from './useColdChainOverview';

const ColdChainSharedContext = createContext(null);

export function ColdChainSharedProvider({ children }) {
  const { temperature } = useFeatures();
  const { data, error, reload } = useColdChainOverview({ enabled: !!temperature });
  const value = useMemo(() => {
    if (!temperature) return null;
    const byDevice = new Map();
    for (const p of data?.points ?? []) {
      if (!byDevice.has(p.deviceId)) byDevice.set(p.deviceId, []);
      byDevice.get(p.deviceId).push(p);
    }
    return { data, error, reload, byDevice };
  }, [temperature, data, error, reload]);
  return <ColdChainSharedContext.Provider value={value}>{children}</ColdChainSharedContext.Provider>;
}

/** The shared overview ({ data, error, reload, byDevice }) or null outside a provider / module off. */
export function useColdChainShared() {
  return useContext(ColdChainSharedContext);
}
